import {
  Card,
  PlusIcon,
  Tag,
  CircleLoading,
} from '@trufla-technology/trumarket-react-design-system';
import { GetProductDefinitionByKey } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types/index';
import {
  useListLocations,
  useUnassignProductDefinitionFromLocation,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import './style.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';
export const ProductCard = ({
  product,
  shouldUpdate,
}: {
  product: GetProductDefinitionByKey;
  shouldUpdate: Boolean;
}) => {
  const { isPermitted } = useAuthContext();
  const {
    data: locations,
    loading,
    get,
  } = useListLocations({
    select: ['key', 'name'],
    filter: { productDefinitionKeys: [(product?.key as string) || ''] },
    paginate: { limit: 100, offset: 0 },
  });
  const { search } = useLocation();

  useEffect(() => {
    if (search === '') {
      setIsActive(false);
    }
  }, [search]);

  useEffect(() => {
    if (shouldUpdate) get();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldUpdate]);

  const history = useHistory();
  const [isActive, setIsActive] = useState(false);
  const removeProductFromBranch = useUnassignProductDefinitionFromLocation();
  const handleAddProductToBranch = (key: string, branches: string) => {
    history.replace({ search: `assign-branch=${key}`, state: { branches } });
  };
  const handleUnAssignProduct = async (
    locationKey: string,
    productDefinitionKey: string,
  ) => {
    await removeProductFromBranch({
      unassigning: [
        {
          productDefinitionKey,
          locationKey,
        },
      ],
    });
    get();
  };
  if (!product) return null;
  return (
    <Card className={isActive ? 'highlighted' : ''}>
      <div className="header">
        {/* TODO: add icon once provided  */}
        <span className="product-title">{product.name}</span>
        {isPermitted('assignProductDefinitionToGroup') && (
          <span
            className="icon"
            onClick={() => {
              handleAddProductToBranch(
                product?.key!,
                locations?.map((location) => location.key)?.join(',')!!,
              );
              setIsActive(true);
            }}
          >
            <PlusIcon />
          </span>
        )}
      </div>
      {locations?.length! > 0 ? (
        <div className="branches">
          {locations?.map((location) => (
            <Tag
              key={location.key}
              icon={
                isPermitted('unassignProductDefinitionFromLocation') ? (
                  <span
                    style={{ boxSizing: 'unset' }}
                    onClick={() =>
                      handleUnAssignProduct(location.key!!, product.key!!)
                    }
                  >
                    {loading ? <CircleLoading /> : <PlusIcon />}
                  </span>
                ) : undefined
              }
            >
              <span>{location.name}</span>
            </Tag>
          ))}
        </div>
      ) : null}
    </Card>
  );
};
